import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TagSettingsCardComponent } from '../tag-settings-card/tag-settings-card.component';

@Component({
    selector: 'itfg-tag-settings-button',
    templateUrl: './tag-settings-button.component.html',
    styleUrls: ['./tag-settings-button.component.scss'],
    standalone: false
})
export class TagSettingsButtonComponent implements OnInit {
  constructor(public dialog: MatDialog) {}

  ngOnInit() {}

  openTagSettings() {
    const dialogRef = this.dialog.open(TagSettingsCardComponent, {
      width: '450px',
      autoFocus: false,
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }
}